import { render, staticRenderFns } from "./ManualTransactionLimitsEditor.vue?vue&type=template&id=cbe2d22e&scoped=true&"
import script from "./ManualTransactionLimitsEditor.vue?vue&type=script&lang=js&"
export * from "./ManualTransactionLimitsEditor.vue?vue&type=script&lang=js&"
import style0 from "./ManualTransactionLimitsEditor.vue?vue&type=style&index=0&id=cbe2d22e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe2d22e",
  null
  
)

export default component.exports